import { createConfigSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';

export const getLoungesApiUrl = createConfigSelector('loungesApiUrl');

export const getBenefitActiveUrl = createSelector(
  getLoungesApiUrl,
  (loungesApiUrl) => `${loungesApiUrl}/member/benefitActive`
);
